import { DealTypeContainer } from '../../containers/advancedFilters/DealTypeContainer';
import { IFilter } from '../../types/advancedFilters';

export const dealType: IFilter = {
  component: DealTypeContainer,
};
